import { UPDATE_LOCALIZATION_INFO, UPDATE_TIMEZONES, UPDATE_UTILITIES_STATUS, UPDATE_CONSTANTS, UPDATE_KIOSK, } from "./types";
var initialState = {
    localization: null,
    timezones: [],
    utilitiesStatus: { isLoading: false },
    constants: undefined,
    kiosk: undefined,
};
export var utilitiesReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_LOCALIZATION_INFO:
            return Object.assign({}, state, { localization: action.payload });
        case UPDATE_TIMEZONES:
            return Object.assign({}, state, { timezones: action.payload });
        case UPDATE_CONSTANTS:
            return Object.assign({}, state, { constants: action.payload });
        case UPDATE_KIOSK:
            return Object.assign({}, state, { kiosk: action.payload });
        case UPDATE_UTILITIES_STATUS:
            return Object.assign({}, state, { utilitiesStatus: action.payload });
        default:
            return state;
    }
};
